export const DEFAULT_FILTER_NAME = '';
export const DEFAULT_FILTER_DATA = {};
export const DEFAULT_DATE_FILTER_DATA = { from: null, to: null };
export const DEFAULT_FILTER_LABEL = {};

export const FilterNames = {
  LOCATION: 'location',
  DATE: 'date',
  GUESTS: 'guests',
  ACTIVITIES: 'activities',
};

export const QueryParamNames = {
  MARKET: 'market',
  REGION: 'region',
  ADULT: 'adult',
  CHILD: 'child',
  INFANT: 'infant',
  DATE_START: 'dateStart',
  DATE_END: 'dateEnd',
  ACTIVITIES: 'activities',
};

export const FILTERS_HOMEPAGE = [FilterNames.LOCATION, FilterNames.DATE, FilterNames.GUESTS];
export const FILTERS_COMMON = [...FILTERS_HOMEPAGE, FilterNames.ACTIVITIES];
